import {
  CLEAR_PAGINATION_STATE,
  GET_PAGINATION_STATE,
  SET_SMSMESSAGES_PAGINATION_STATE,
  SET_GROUPS_PAGINATION_STATE,
  SET_GROUPCONTACTS_PAGINATION_STATE,
  SET_SENDHISTORY_PAGINATION_STATE,
  SET_SHEDULEDSEND_PAGINATION_STATE,
  SET_RECIPIENTS_PAGINATION_STATE,
  SET_OPTINS_PAGINATION_STATE,
  SET_PAINDING_PAGINATION_STATE,
  SET_OPTOUT_PAGINATION_STATE,
  SET_INVALID_PAGINATION_STATE,
  SET_SUCCSEND_MESSAGESTATISTICS_STATE,
  SET_TEXTRESPONSE_PAGINATION_STATE,
  SET_PAYMENT_SHORTLINK_PAGINATION_STATE,
  SET_ACTIVEEVENTS_PAGINATION_STATE,
  SET_ENDEDEVENTS_PAGINATION_STATE,
} from "./PaginationRowType";

const initialState = {
  smsMessagesState: {},
  groupsState: {},
  groupContactsState: {},
  optinContactsState: {},
  paindingContactsState: {},
  optoutContactsState: {},
  invalidContactsState: {},
  sendHistoryState: {},
  scheduledSendState: {},
  outgoingMsgState: {},
  succSendMsgStatsState: {},
  textResponseMsgStatsState: {},
  paymetShortLinkState: {},
  activeEventsState: {},
  endedEventsState: {},
};

const PaginationRowReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAGINATION_STATE:
      return {
        ...state,
      };
    case SET_SMSMESSAGES_PAGINATION_STATE:
      return {
        ...state,
        smsMessagesState: action.payload.smsMessagesState,
      };
    case SET_GROUPS_PAGINATION_STATE:
      return {
        ...state,
        groupsState: action.payload.groupsState,
      };
    case SET_GROUPCONTACTS_PAGINATION_STATE:
      return {
        ...state,
        groupContactsState: action.payload.groupContactsState,
      };
    case SET_OPTINS_PAGINATION_STATE:
      return {
        ...state,
        optinContactsState: action.payload.optinContactsState,
      };
    case SET_PAINDING_PAGINATION_STATE:
      return {
        ...state,
        paindingContactsState: action.payload.paindingContactsState,
      };
    case SET_OPTOUT_PAGINATION_STATE:
      return {
        ...state,
        optoutContactsState: action.payload.optoutContactsState,
      };
    case SET_INVALID_PAGINATION_STATE:
      return {
        ...state,
        invalidContactsState: action.payload.invalidContactsState,
      };
    case SET_SENDHISTORY_PAGINATION_STATE:
      return {
        ...state,
        sendHistoryState: action.payload.sendHistoryState,
      };
    case SET_SHEDULEDSEND_PAGINATION_STATE:
      return {
        ...state,
        scheduledSendState: action.payload.scheduledSendState,
      };
    case SET_RECIPIENTS_PAGINATION_STATE:
      return {
        ...state,
        outgoingMsgState: action.payload.outgoingMsgState,
      };
    case SET_SUCCSEND_MESSAGESTATISTICS_STATE:
      return {
        ...state,
        succSendMsgStatsState: action.payload.succSendMsgStatsState,
      };

    case SET_TEXTRESPONSE_PAGINATION_STATE:
      return {
        ...state,
        textResponseMsgStatsState: action.payload.textResponseMsgStatsState,
      };

    case SET_PAYMENT_SHORTLINK_PAGINATION_STATE:
      return {
        ...state,
        paymetShortLinkState: action.payload.paymetShortLinkState,
      };

    case SET_ACTIVEEVENTS_PAGINATION_STATE:
      return {
        ...state,
        activeEventsState: action.payload.activeEventsState,
      };
    case SET_ENDEDEVENTS_PAGINATION_STATE:
      return {
        ...state,
        endedEventsState: action.payload.endedEventsState,
      };

    case CLEAR_PAGINATION_STATE:
      return {
        ...state,
        smsMessagesState: null,
        groupsState: null,
        groupContactsState: null,
        optinContactsState: null,
        paindingContactsState: null,
        optoutContactsState: null,
        invalidContactsState: null,
        sendHistoryState: null,
        scheduledSendState: null,
        outgoingMsgState: null,
        succSendMsgStatsState: null,
        textResponseMsgStatsState: null,
        paymetShortLinkState: null,
        activeEventsState: null,
        endedEventsState: null,
      };
    default:
      return state;
  }
};

export default PaginationRowReducer;
